/* @flow */
import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    width: '100%',
  },
  inputRoot: {
    '& fieldset': {
      borderColor: ({ theme }: ThemeFunction) => theme.textColor,
    },
  },
  input: {
    border: 'none !important',
    outline: 'none !important',
    color: ({ theme }: ThemeFunction) => `${theme.textColor} !important`,
  },
  startAdornment: {
    color: ({ theme }: ThemeFunction) => theme.textColor,
  },
  endAdornment: {
    top: 'calc(50% - 16px) !important',
    color: ({ theme }: ThemeFunction) => theme.textColor,

    '& .MuiButtonBase-root': {
      minWidth: '32px !important',
      minHeight: '32px !important',
    },
  },
};
